import LoginError from './LoginError';
class InvalidCredentials extends LoginError {
    constructor(options) {
        super('Credentials provided by user are not valid', options);
    }
}
export default InvalidCredentials;
